import styled from '@emotion/styled';

export const SadaActivityList = styled.div`
  width: 100%;
`;
